import React from "react";
import "./App.css";
import AppRoute from "./appRouting";

function App() {
  
  return (
    <div>
      <AppRoute />
    </div>
  );
}

export default App;
